import { useEffect, useState } from "react";
export var HEIGHT_LIMIT = 1500;
export var useCollapse = function(allowCollapse, ref) {
    var _$ref = useState(false), isCollapsed = _$ref[0], setIsCollapsed = _$ref[1];
    var _$ref1 = useState(false), canBeCollapsed = _$ref1[0], setCanBeCollapsed = _$ref1[1];
    useEffect(function() {
        if (ref.current && allowCollapse) {
            // collapse the whole content if the height of the ref wrapping div is higher than the set limit
            setIsCollapsed(ref.current.clientHeight >= HEIGHT_LIMIT);
        } else {
            setIsCollapsed(false);
        }
    }, [
        ref,
        allowCollapse
    ]);
    useEffect(function() {
        if (ref.current && ref.current.clientHeight > HEIGHT_LIMIT) {
            setCanBeCollapsed(true);
        }
    }, [
        ref
    ]);
    return {
        canBeCollapsed: canBeCollapsed,
        isCollapsed: isCollapsed,
        setIsCollapsed: setIsCollapsed
    };
};
